// @ts-nocheck

import React, { FunctionComponent, useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Select } from 'antd'
import 'react-phone-number-input/style.css'
import flags from 'country-flag-icons/react/3x2'

import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next'
import * as yup from 'yup'

import { ArrowTotalBtnDown } from 'Stories/Icon/Icon.stories'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import { fillingRegisterFormEvent, locationEvent } from 'Helpers/tagManager'

import {
  GreenBtn,
  GreenBtnWide,
  GreyBtnDisabled,
  GreyBtnDisabledWide,
} from 'Stories/Button/Button.stories'

import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input'
import { arrPhoneCodes } from 'Helpers/validation'
import { FormDataProps, UserRegisterFormProps } from './UserRegisterFormProps'

import {
  RegisterForm,
  InputContainer,
  Input,
  PhoneNumberInput,
  RedInput,
  Label,
  RedLabel,
  SelectContainer,
  ErrorText,
  BtnContainer,
  PhoneInfo,
  ExistingEmailBlock,
  ExistingEmailText,
  RegisterLogin,
  LoginLink,
} from './styles'

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
const { Option } = Select

const UserRegisterForm: FunctionComponent<UserRegisterFormProps> = ({
  country,
  onSubmit,
  emailExist,
  setGTMevent,
  handleResetEmailExist,
}) => {
  const { t } = useTranslation()

  const schema = yup.object().shape({
    firstName: yup
      .string()
      .min(2, i18n.t('createCampaignPage.firstNameMustBeAtLeast2Characters'))
      .max(30, i18n.t('createCampaignPage.firstNameMustBeLessThan30'))
      .required(i18n.t('createCampaignPage.pleaseEnterTheRequiredField')),
    lastName: yup
      .string()
      .min(2, i18n.t('createCampaignPage.lastNameMustBeAtLeast2Characters'))
      .max(30, i18n.t('createCampaignPage.lastNameMustBeLessThan30'))
      .required(i18n.t('createCampaignPage.pleaseEnterTheRequiredField')),
    email: yup
      .string()
      .email(i18n.t('createCampaignPage.invalidEmailAddress'))
      .required(i18n.t('createCampaignPage.pleaseEnterTheRequiredField')),
  })

  const {
    register,
    watch,
    handleSubmit,
    control,
    setError,
    formState: { errors, isValid, isDirty },
  } = useForm<FormDataProps>({
    criteriaMode: 'firstError',
    reValidateMode: 'onBlur',
    mode: 'onBlur',
    resolver: yupResolver(schema),
  })

  const roles = ['artist', 'agent', 'label', 'manager', 'publisher']

  const watchFirstName = watch('firstName', '')
  const watchLastName = watch('lastName', '')
  const watchEmail = watch('email', '')
  const watchRole = watch('role', '')

  const startFillingForm = () => {
    locationEvent()
    fillingRegisterFormEvent()
  }

  const [phoneNumberValidMessage, setPhoneNumberValidMessage] = useState('')

  useEffect(() => {
    if (!watch('phone_number')) {
      setPhoneNumberValidMessage('')
    }
  }, [watch('phone_number')])

  const showMessageAndSemdGTMEvent = () => {
    ![t('createCampaignPage.invalidNumber')].includes(
      phoneNumberValidMessage
    ) &&
      setPhoneNumberValidMessage(
        t('createCampaignPage.youCanGetQuickResultIfYouLeaveYourPhone')
      )
    setGTMevent()
  }

  const changeMessageHandler = (phoneNumber: string) => {
    setPhoneNumberValidMessage(
      !isPossiblePhoneNumber(phoneNumber) &&
        !isValidPhoneNumber(phoneNumber) &&
        t('createCampaignPage.invalidNumber')
    )
  }

  const isButtonDisable =
    !isValid ||
    !isDirty ||
    !roles.includes(watchRole) ||
    t('createCampaignPage.invalidNumber') === phoneNumberValidMessage

  const [isRoleNecessary, setRoleNecessary] = useState<boolean>(false)

  useEffect(() => {
    setRoleNecessary(false)
  }, [roles.includes(watchRole)])

  return (
    <>
      <RegisterForm onSubmit={handleSubmit(onSubmit)}>
        <InputContainer>
          {!errors.firstName?.message && watchFirstName.length === 0 && (
            <Label htmlFor="firstName" />
          )}
          {!errors.firstName?.message && watchFirstName.length !== 0 && (
            <Label htmlFor="firstName">{t('signup.firstName')}</Label>
          )}
          {errors.firstName?.message && watchFirstName.length !== 0 && (
            <RedLabel htmlFor="firstName">{t('signup.firstName')}</RedLabel>
          )}

          {!errors.firstName?.message ? (
            <Input
              name="firstName"
              placeholder="First Name"
              type="text"
              {...register('firstName')}
              onFocus={startFillingForm}
            />
          ) : (
            <RedInput name="firstName" type="text" {...register('firstName')} />
          )}
          {errors.firstName?.message ? (
            <ErrorText>{errors.firstName.message}</ErrorText>
          ) : null}
        </InputContainer>

        <InputContainer>
          {!errors.lastName?.message && watchLastName.length === 0 && (
            <Label htmlFor="lastName" />
          )}
          {!errors.lastName?.message && watchLastName.length !== 0 && (
            <Label htmlFor="lastName">{t('signup.lastName')}</Label>
          )}
          {errors.lastName?.message && watchLastName.length !== 0 && (
            <RedLabel htmlFor="lastName">{t('signup.lastName')}</RedLabel>
          )}

          {!errors.lastName?.message ? (
            <Input
              name="lastName"
              placeholder="Last Name"
              type="text"
              {...register('lastName')}
            />
          ) : (
            <RedInput name="lastName" type="text" {...register('lastName')} />
          )}
          {errors.lastName?.message ? (
            <ErrorText>{errors.lastName?.message}</ErrorText>
          ) : null}
        </InputContainer>

        <InputContainer>
          {!errors.email?.message && watchEmail.length === 0 && (
            <Label htmlFor="email" />
          )}
          {!errors.email?.message && watchEmail.length !== 0 && (
            <Label htmlFor="email">{t('login.email')}</Label>
          )}
          {errors.email?.message && watchEmail.length !== 0 && (
            <RedLabel htmlFor="email">{t('login.email')}</RedLabel>
          )}
          {emailExist && (
            <RedLabel htmlFor="email">{t('login.email')}</RedLabel>
          )}

          {!errors.email?.message && !emailExist && (
            <Input
              name="email"
              placeholder="Email"
              type="email"
              {...register('email')}
            />
          )}
          {errors.email?.message && !emailExist && (
            <RedInput name="email" type="email" {...register('email')} />
          )}
          {emailExist && (
            <RedInput
              name="email"
              type="email"
              {...register('email')}
              onBlur={handleResetEmailExist}
            />
          )}

          {errors.email?.message ? (
            <ErrorText>{errors.email?.message}</ErrorText>
          ) : null}

          {emailExist ? (
            <ExistingEmailBlock>
              <ExistingEmailText>
                {t('createCampaignPage.useAnotherEmailToRegisterOr')}
              </ExistingEmailText>
              &nbsp;
              <LoginLink href={document.location.origin}>
                <Desktop>
                  <RegisterLogin>
                    {t('createCampaignPage.loginWithYourAccount')}
                  </RegisterLogin>
                </Desktop>
                <Mobile>
                  <RegisterLogin>{t('createCampaignPage.login')}</RegisterLogin>
                </Mobile>
              </LoginLink>
            </ExistingEmailBlock>
          ) : null}
        </InputContainer>

        <InputContainer>
          <SelectContainer isRoleNecessary={isRoleNecessary}>
            <Controller
              control={control}
              name="role"
              render={({ field: { onChange } }) => (
                <Select
                  placeholder="Role"
                  suffixIcon={<ArrowTotalBtnDown />}
                  {...register('role')}
                  dropdownStyle={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.25))',
                    color: '#646877',
                    padding: '0px 16px',
                  }}
                  onChange={onChange}
                  onBlur={() =>
                    !roles.includes(watchRole) && setRoleNecessary(true)
                  }
                >
                  {roles.map(item => (
                    <Option
                      key={item}
                      value={item}
                      style={{
                        color: '#646877',
                        backgroundColor: '#ffffff',
                        padding: '13.5px 0px',
                        fontWeight: 'normal',
                        borderBottom: '1px solid #F3F4F7',
                        lineHeight: '21px',
                      }}
                    >
                      {t(`createCampaignPage.${item}`)}
                    </Option>
                  ))}
                </Select>
              )}
            />
            {isRoleNecessary && (
              <ErrorText>
                {t('createCampaignPage.pleaseEnterTheRequiredField')}
              </ErrorText>
            )}
          </SelectContainer>
        </InputContainer>

        <InputContainer>
          <PhoneNumberInput
            addInternationalOption={false}
            defaultCountry={country}
            control={control}
            international
            flags={flags}
            type="tel"
            value={register('phone_number').name}
            name="phone_number"
            withCountryCallingCode
            placeholder="Phone (optional)"
            autoComplete="off"
            onChange={number => {
              if (arrPhoneCodes.includes(number)) {
                setPhoneNumberValidMessage(
                  t(
                    'createCampaignPage.youCanGetQuickResultIfYouLeaveYourPhone'
                  )
                )
              }
              if (number && !arrPhoneCodes.includes(number)) {
                changeMessageHandler(number)
              }
            }}
            onKeyDown={evt =>
              (evt.key === 'e' || evt.key === '-') && evt.preventDefault()
            }
            onFocus={showMessageAndSemdGTMEvent}
          />
          {phoneNumberValidMessage && (
            <PhoneInfo
              color={
                phoneNumberValidMessage ===
                  t('createCampaignPage.invalidNumber') && 'darkOrange'
              }
            >
              {phoneNumberValidMessage}
            </PhoneInfo>
          )}
        </InputContainer>

        <Desktop>
          <BtnContainer>
            {isButtonDisable ? (
              <GreyBtnDisabledWide
                color="greyDisabledWide"
                onClick={() => {
                  !roles.includes(watchRole) && setRoleNecessary(true)
                }}
              >
                {t('login.continue')}
              </GreyBtnDisabledWide>
            ) : (
              <GreenBtnWide type="submit" color="greenWide">
                {t('login.continue')}
              </GreenBtnWide>
            )}
          </BtnContainer>
        </Desktop>

        <Mobile>
          <BtnContainer>
            {isButtonDisable ? (
              <GreyBtnDisabled
                color="greyDisabled"
                onClick={() => {
                  !roles.includes(watchRole) && setRoleNecessary(true)
                }}
              >
                {t('login.continue')}
              </GreyBtnDisabled>
            ) : (
              <GreenBtn type="submit" color="green">
                {t('login.continue')}
              </GreenBtn>
            )}
          </BtnContainer>
        </Mobile>
      </RegisterForm>
    </>
  )
}

export default UserRegisterForm
